import apiClient from './apiClient'

export interface ContractorListItem {
  id: number
  companyName: string
  ico: string
  contactFirstName: string
  contactLastName: string
  contactEmail: string
  phone: string | null
  orbitEmail: string | null
  expectedActivities: string | null
  contractEndDate: string | null
  cooperationStartDate: string | null
  isActive: boolean
  managerFullName: string | null
  departmentName: string | null
}

export interface ContractorDetail {
  id: number
  companyName: string
  ico: string
  isVatPayer: boolean
  contactFirstName: string
  contactLastName: string
  contactEmail: string
  phone: string | null
  birthDate: string | null
  expectedActivities: string | null
  contractStartDate: string
  contractEndDate: string | null
  cooperationStartDate: string | null
  isActive: boolean
  departmentId: number | null
  departmentName: string | null
  managerId: number | null
  managerFullName: string | null
  orbitEmail: string | null
  note: string | null
}

export interface ContractorForm {
  companyName: string
  ico: string
  isVatPayer?: boolean
  contactFirstName: string
  contactLastName: string
  contactEmail: string
  phone?: string
  birthDate?: string
  expectedActivities?: string
  contractStartDate: string
  contractEndDate?: string
  cooperationStartDate?: string
  isActive?: boolean
  departmentId?: number
  managerId?: number
  orbitEmail?: string
  note?: string
}

export interface PagedResult<T> {
  items: T[]
  totalCount: number
  page: number
  pageSize: number
}

export const contractorsService = {
  getAll: (params: { search?: string; isActive?: boolean; page?: number; pageSize?: number; managerSearch?: string } = {}) =>
    apiClient.get<PagedResult<ContractorListItem>>('/contractors', { params }).then(r => r.data),

  getById: (id: number) =>
    apiClient.get<ContractorDetail>(`/contractors/${id}`).then(r => r.data),

  checkEmail: (email: string) =>
    apiClient.get<{ isTaken: boolean; contractorName: string | null }>('/contractors/check-email', { params: { email } }).then(r => r.data),

  create: (data: ContractorForm) =>
    apiClient.post<{ id: number }>('/contractors', data).then(r => r.data),

  update: (id: number, data: ContractorForm & { isActive: boolean }) =>
    apiClient.put(`/contractors/${id}`, { id, ...data }),

  deactivate: (id: number) =>
    apiClient.delete(`/contractors/${id}`),

  permanentDelete: (id: number) =>
    apiClient.delete(`/contractors/${id}/permanent`),
}
